const contactGallerySlider = {
    selector: '.js-contact-gallery-slider',
    active: false,
    arrowClass: 'contact-gallery__arrow',
    settings: {
        infinite: false,
        autoplay: true,
        speed: 400,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    }
}


$(function() {
    initSlickSlider(contactGallerySlider);

    $('img, .is-image').on('mousedown contextmenu', function(e) {
        e.preventDefault()

        return false;
    });
});